import React, { useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import { ModalSubmit, Spinner, MultiSelect } from "components/common";
import { Alert, Modal } from "components/bootstrap";
import streamCategoryName from "logic/streams/streamCategoryName";
import useStreamCategories from "illuminate/hooks/useStreamCategories";
import useStreamCategoryMutation from "illuminate/hooks/useStreamCategoryMutation";
const StreamCategoriesModal = React.forwardRef(
  ({ entity: stream, entityType, onClose = void 0 }, ref) => {
    const { t } = useTranslation("enterprise_illuminate");
    const [showModal, setShowModal] = useState(false);
    const [selectedCategories, setSelectedCategories] = useState("");
    const { categories: streamCategories, isLoading: loadingCategories } = useStreamCategories(showModal);
    const { updateCategories } = useStreamCategoryMutation();
    useImperativeHandle(ref, () => ({
      toggle: () => {
        var _a;
        setSelectedCategories(((_a = stream.categories) != null ? _a : []).join(","));
        setShowModal(true);
      }
    }));
    const closeModal = () => {
      setShowModal(false);
      if (onClose) onClose();
    };
    const categoryOptions = streamCategories.map((category) => ({
      value: category,
      label: streamCategoryName(category)
    }));
    const handleSubmit = () => {
      const categories = selectedCategories ? selectedCategories.split(",") : [];
      updateCategories.mutate({ streamId: stream.id, categories }, { onSuccess: closeModal });
    };
    if (entityType !== "stream") {
      return null;
    }
    return /* @__PURE__ */ React.createElement(Modal, { onHide: closeModal, show: showModal }, /* @__PURE__ */ React.createElement(Modal.Header, { showCloseButton: true }, /* @__PURE__ */ React.createElement(Modal.Title, null, t("stream_categories_modal.title", { title: stream.title }))), /* @__PURE__ */ React.createElement(Modal.Body, null, loadingCategories ? /* @__PURE__ */ React.createElement(Spinner, { text: t("stream_categories_modal.loading_categories") }) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, t("stream_categories_modal.select_info")), /* @__PURE__ */ React.createElement(
      MultiSelect,
      {
        id: "stream-categories-select",
        placeholder: t("stream_categories_modal.select_placeholder"),
        options: categoryOptions,
        value: selectedCategories,
        onChange: (value) => setSelectedCategories(value),
        allowCreate: true
      }
    ))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
      ModalSubmit,
      {
        submitButtonText: t("stream_categories_modal.submit_button"),
        submitLoadingText: t("stream_categories_modal.submit_loading"),
        onCancel: closeModal,
        isAsyncSubmit: true,
        isSubmitting: updateCategories.isPending,
        onSubmit: handleSubmit,
        submitButtonType: "button"
      }
    )));
  }
);
export default StreamCategoriesModal;
